@import "components/recipe/recipe-theme";
@import "components/select/select-theme";
@import "components/select-checkbox/select-checkbox-theme";
@import "components/multi-select/multi-select-theme";
@import "components/incdec/incdec-theme";
@import "components/switch/switch-theme";
@import "components/settings/settings-theme";

$app-menu-color: 'white' !default;
$app-container-color: '#223041' !default;
$app-border-color: '#536A7A' !default;
$app-links-background1: '#212F3E' !default;
$app-links-background2: '#17232E' !default;
$app-links-btn-background1: '#182A38' !default;
$app-links-btn-background2: '#2A475B' !default;
$app-links-btn-color: 'white' !default;
$app-upload-background: '#111c27' !default;
$app-upload-color: 'white' !default;
$app-upload-border: '2px dashed' !default;

.container-fluid {

  .file {
    .upload {
      background: #{$app-upload-background};
      color: #{$app-upload-color};
      border: #{$app-upload-border};
    }
    .btn-file {
      background: linear-gradient(0deg, #{$app-links-btn-background1}, #{$app-links-btn-background2});
    }
  }

  .btn-menu {
    color: #{$app-menu-color};
    .dots {
    }
  }

  .main {
    //border-top: 1px solid #{$app-border-color};
    .mobile-save-block {
      .btn-menu-mobile {
        color: #{$app-menu-color};
      }
    }
    .btn-mobile {
      background: linear-gradient(0deg, #{$app-links-btn-background1}, #{$app-links-btn-background2});
      color: #{$app-links-btn-color};
    }
    .main-content {
      display: table;
      .mobile-links {
        border-right: 1px solid #{$app-border-color} !important;
      }
      .links {
        background: linear-gradient(90deg, #{$app-links-background1}, #{$app-links-background2});
        border: 1px solid #{$app-border-color};
      }
    }
  }

  .border-top{
    border-top: 1px solid #{$app-border-color};
  }
}

.content-container {
  background: #{$app-container-color};
}




// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/app-theme.scss